<template>
  <div ref="vdmSampledata" id="vdmSampledata" class="bringins-content">
    <div class="return-btn" @click="returnFunc()">
      <span></span>
    </div>
    <div class="shed">
      <div class="shed-content">
        <el-tabs v-model="tabName">
          <!--el-tab-pane label="基本信息" name="basicInfo">
            <div
              v-if="loading"
              :style="{ width: '100%', height: sampledataHeight + 'px' }"
            >
              <check-loading ref="checkLoading" v-if="loading"></check-loading>
            </div>
            <div v-else-if="!loading"></div>
          </el-tab-pane-->
          <el-tab-pane :label="'料棚全景监控 - ' + shedName" name="emissionSource">
            <div class="infor_box">
              <div class="infor_inner box" style="width: 100%">
                <div class="infor_params">
                  <div class="title">
                    <img src="./img/icon_gear_default.png" />
                    <span>产区信息</span>
                  </div>
                  <div class="infor_params_box">
                    <p>
                      <label for="">分厂/所属区域：</label>
                      <span class="infor_params_value">{{ areaName }}</span>
                    </p>
                    <p>
                      <label for="">详细设备类型：</label>
                      <span class="infor_params_value">VDM15000</span>
                    </p>
                    <p>
                      <label for="">设备编码：</label>
                      <span class="infor_params_value">{{ shedId }}</span>
                    </p>
                  </div>
                </div>

                <div class="infor_params">
                  <div class="title">
                    <img src="./img/icon_gear_default.png" />
                    <span>基本信息</span>
                  </div>
                  <div class="infor_params_box">
                    <p>
                      <label for="">料棚面积：</label>
                      <span class="infor_params_value">{{ area }}</span>
                    </p>
                    <p>
                      <label for="">存储物料：</label>
                      <span class="infor_params_value">{{ materialName }}</span>
                    </p>
                    <p v-for="(item, n) in materialShedDeviceTypeList" v-bind:key="n">
                      <label>{{ item.lastType }}：</label>
                      <span class="infor_params_value">{{ item.count }}</span>
                    </p>
                  </div>
                </div>

                <vdm-bar style="margin-top:100px;" v-if="shedId" :shedId="shedId"></vdm-bar>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { unref, computed } from "vue";
import { dateFormat, unwarp } from "@/utils/tools.js";
import checkLoading from "@/modules/checkLoading";
import vdmBar from "./vdmBar.vue";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    checkLoading,
    vdmBar,
  },
  props: {},
  inject: [
    "getVdmArea",
    "getAllEmissionVdmId",
    "getAllEmissionVdmName",
    "updateVdmArea",
    "updateInventorySwitch",
    "updateInventoryId",
    "updateLeftRightPart",
    "updateSourceShow",
    "updateEmissionLoading",
    "updateAllEmissionVdmId",
    "clearDustTimer",
  ],
  data() {
    //这里存放数据
    return {
      pageInfo: 'vdmBar/index.vue',
      computedName: '料棚全景监控弹框组件',
      customerId: this.$store.state.customerId,
      shedId: "",
      tabName: "emissionSource",
      shedName: "",
      loading: true,
      loading2: true,
      sampledataHeight: 200,
      materialId: "",
      shedInfo: "",
      area: "",
      areaName: "",
      materialName: "",
      materialShedDeviceTypeList: [],
      shedVideos: [],
      shedDeviceObj: [],
      timeArr: [
        dateFormat("YYYY-mm-dd", new Date()) + " 00:00:00",
        dateFormat("YYYY-mm-dd HH:MM:SS", new Date()),
      ],
    };
  },
  //计算属性 类似于data概念
  computed: {},
  provide: function () {
    return {
      getShedId: computed(() => this.shedId),
    };
  },
  //监控data中的数据变化
  watch: {
    getVdmArea: {
      handler(newVal, oldVal) {
        //debugger;
        this.materialObj = unref(newVal);
        //this.$forceUpdate();
        if (this.materialObj) {
          let that = this;
          that.signalList = [];
          this.shedId = this.materialObj.shedNo;
          this.shedName = this.materialObj.shedName;
          setTimeout(function () {
            that.changeBringins();
            that.getShedList();
            $(".bringins-block").css("left", "-25%");
          }, 500);
        }
      },
      deep: true,
    },
    getAllEmissionVdmId: {
      handler(newVal, oldVal) {
        this.shedId = unref(newVal);
        this.allEmissionShedId = this.shedId;
        this.materialObj = {
          shedNo: this.shedId,
        };
        if (this.shedId) {
          let that = this;
          setTimeout(function () {
            that.changeBringins();
            that.getShedList();
            $(".bringins-block").css("left", "-25%");
          }, 500);
        }
      },
      deep: true,
    },
    getAllEmissionVdmName: {
      handler(newVal, oldVal) {
        this.shedName = unref(newVal);
      },
      deep: true,
    },
    /*imgIdx: {
      handler(newVal) {
        console.log(JSON.stringify(newVal));
        let idx = newVal.idx;
        $("a[idx='jDiaporama_" + idx + "']").click();
        $("li[idx='jDiaporama_" + idx + "']").mouseenter();
      },
      deep: true,
    },*/
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    $(this.$refs.vdmSampledata).hide();
  },
  //方法集合
  methods: {
    changeBringins() {
      $(this.$refs.vdmSampledata).bringins();
    },
    returnFunc() {
      this.shedId = false;
      this.$forceUpdate();
      if (this.allEmissionShedId) {
        this.allEmissionShedId = "";
        $(".bringins-block").fadeOut(500, function () {
          $(".bringins-block").remove();
        });
        if (this.updateAllEmissionVdmId) {
          this.updateAllEmissionVdmId(this.allEmissionShedId);
        }
      } else {
        this.updateVdmArea("");
        this.updateInventorySwitch(false);
        this.updateInventoryId(false);
        this.updateLeftRightPart(false);
        this.updateSourceShow(false);
        this.updateEmissionLoading(false);
        $(".bringins-block").fadeOut(500, function () {
          $(".bringins-block").remove();
        });
      }
    },
    record_check_click() {
      this.getVdmList();
    },
    record_reset_click() {
      this.timeArr = [
        dateFormat("YYYY-mm-dd", new Date()) + " 00:00:00",
        dateFormat("YYYY-mm-dd HH:MM:SS", new Date()),
      ];
      this.getVdmList();
    },
    date_change(e) {
      this.timeArr = [
        dateFormat("YYYY-mm-dd HH:MM:SS", e[0]),
        dateFormat("YYYY-mm-dd HH:MM:SS", e[1]),
      ];
    },
    async getShedList() {
      this.loading2 = true;
      let shedInfo = await this.findMaterialClose();
      this.areaName = shedInfo.basic.areaName;
      this.materialName = shedInfo.basic.material;
      this.area = shedInfo.basic.area;

      this.materialShedDeviceTypeList = [];
      for (let i in shedInfo.count) {
        this.materialShedDeviceTypeList.push({
          lastType: i,
          count: shedInfo.count[i],
        });
      }
      this.loading2 = false;
    },
    async findMaterialClose() {
      let findVdmDetailUrl = CONFIG.requestName + this.$apiOpt.vdmDetail;
      //let findMaterialCloseUrl = CONFIG.requestName + this.$apiOpt.findMaterialClose;
      //let findMaterialCloseUrl = "https://vis.bmetech.com/vis/vdm15000/detail";
      return this.$apiUtils.get(findVdmDetailUrl, {
        customerId: this.$store.state.customerId,
        shedNo: this.materialObj.shedNo,
      });
    },
  },
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
  deactivated() {
    if (this.getDustTimer) {
      clearTimeout(this.getDustTimer);
    }
  },
  beforeUnmount() {
    if (this.getDustTimer) {
      clearTimeout(this.getDustTimer);
    }
  },
};
</script>
<style lang="scss">
.shed {
  position: relative;
  width: 100%;
  height: 100%;

  .VDMbutton {
    width: 40px;
    height: 60px;
    cursor: pointer;
  }
  .left {
    background-image: url(img/leftBut.png);
    background-size: 100% 100%;
  }
  .right {
    background-image: url(img/rightBut.png);
    background-size: 100% 100%;
  }

  .el-tabs__content {
    position: absolute !important;
    top: 120px !important;
    bottom: 50px !important;
    left: 50px !important;
    right: 30px !important;
    overflow: auto !important;
  }
}

.shed {
  .monitor {
    //@include bg-box(560px, 230px, "1.png");
    //margin: 29px auto 15px;
    position: relative;
    bottom: 10px;
    top: 60px;
    left: 20px;
    right: 20px;

    .el-tabs--border-card {
      background: initial !important;
      border: initial !important;
    }

    .el-tabs--border-card > .el-tabs__header {
      background: initial !important;
      border: initial !important;
    }

    .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
      background: #2dacd24d !important;
      border: initial !important;
      color: #65f5f2 !important;
      font-family: "normalFont";
    }

    .el-tabs__content {
      position: relative !important;
      padding: 15px 0;
      width: 100%;
      overflow: auto;
      top: 0px !important;
      left: 5px !important;
      right: 0px !important;
      .vdm-image {
        width: 100%;
      }
    }
  }
}

.shed-content {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background: url(/static/img/img_bg.png);
  background-size: 100% 100%;
  padding: 25px 25px;
  font-size: 12px;
}

.shed .el-tabs__item {
  color: #fff !important;
  font-size: 32px !important;
  line-height: 80px;
  height: 80px;
  padding: 0 30px 0 30px !important;
}

.shed .el-tabs__item.is-active {
  color: #3fad92 !important;
  font-size: 32px !important;
  line-height: 80px;
  height: 80px;
  padding: 0 30px 0 30px !important;
}

.return-btn {
  background-image: url("/static/img/return.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 160px;
  height: 50px;
  position: absolute;
  top: 26px;
  right: 50px;
  z-index: 1;
  cursor: pointer;
}

.return-btn > span {
  font-size: 30px;
  left: 80px;
  top: 6px;
  position: relative;
}

.equipType {
  font-size: 24px;
  line-height: 24px;
  color: #3fad92;
}

.title-img {
  display: inline-block;
  vertical-align: middle;
  margin-right: 15px;
}

.title span {
  font-size: 24px;
  line-height: 24px;
}
</style>

<style lang="scss" scoped="scoped">
.dust_bar {
  width: 1730px;
  height: 540px;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1002;
  pointer-events: none;
  .dust {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 1px;
    height: 1px;
    background-image: url(images/dust.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    animation: dust 5s linear;
    animation-fill-mode: forwards;
    transform-origin: center center;
  }
}
@keyframes dust {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(100);
  }
  100% {
    transform: scale(150);
  }
}

.heart_box {
  width: 1730px;
  height: 540px;
  /* transform: scale(6.5); */
  /* left: 700px; */
  /* top: 100px; */
  position: absolute;
  background-image: radial-gradient(rgba(0, 0, 0, 0.6) 40%, transparent);
  overflow: hidden;
  z-index: 999;
}
.heart_box .heart {
  position: absolute;
  width: 50px;
  height: 50px;
  background-size: 100% 100%;
  background-image: url(images/quan_circle.png);
  left: 840px;
  top: 245px;
}
.heart_box .shan {
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 844px;
  height: 516px;
  background-image: url(images/quan_rotate.png);
  top: -246px;
  left: 443px;
  position: absolute;
  transform-origin: center bottom;
  transform: rotate(0deg);
  -webkit-animation: radar 5s linear infinite;
  animation: radar 5s linear infinite;
}
@keyframes radar {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes aura {
  25%,
  75% {
    border-radius: 60% 40% 40% 60% / 60% 40% 60% 40%;
  }
  50% {
    border-radius: 40% 60% 60% 40% / 40% 60% 40% 60%;
  }
  100% {
    transform: rotate(360deg);
  }
}

.shed-bar {
  position: relative;
  width: 1730px;
  height: 540px;

  ul {
    width: 80px;
    height: 80px;
    position: absolute;
    left: 210px;
    top: 10px;
    z-index: 1000;
    transform: rotateX(45deg);
  }
  ul[class="unselected"]::after {
    content: "";
    position: absolute;
    top: 5px;
    right: 5px;
    bottom: 5px;
    left: 5px;
    background: radial-gradient(
      circle,
      #1a1a1aff 10%,
      #000000b6 50%,
      #000000ff
    );
    border-radius: 50%;
  }
  ul[class="selected"]::after {
    content: "";
    position: absolute;
    top: 5px;
    right: 5px;
    bottom: 5px;
    left: 5px;
    border-radius: 50%;
    background: radial-gradient(
      circle,
      #1a1a1aff 10%,
      #000000b6 50%,
      #000000ff
    );
    animation: selected 3s infinite linear;
  }

  @keyframes selected {
    0% {
      opacity: 0.8;
    }
    25% {
      opacity: 0.6;
    }
    50% {
      opacity: 0.4;
    }
    75% {
      opacity: 0.6;
    }
    100% {
      opacity: 0.8;
    }
  }

  ul li {
    border-radius: 50%;
    background-color: yellow;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    animation: aura 1.2s infinite linear;
    mix-blend-mode: screen;
    filter: blur(0.5vw);
  }
  ul li:nth-child(2) {
    background-color: magenta;
    animation-delay: -0.4s;
  }
  ul li:nth-child(3) {
    background-color: cyan;
    animation-direction: reverse;
    animation-delay: -0.8s;
  }
}

.shed-video {
  position: absolute;
  width: 1730px;
  height: 540px;
}
.shed-photo {
  z-index: 1001;
}
.shed-shadow {
  position: absolute;
  width: 1730px;
  height: 540px;
  top: 0px;
  left: 0px;
  background: rgba(0, 0, 0, 0.35);
}
.shed_inner {
  position: relative;
  /* left: 0px; */
  /* top: 0px; */
  width: 300px;
  height: 100px;
  text-align: center;
  margin: auto;
  left: 0px;
  top: -30px;
  z-index: 1001;
}
.shedEquip {
  z-index: 1;
  pointer-events: none;
}
.shedEquipHover {
  z-index: 99 !important;
}
.hasSignal {
  z-index: 100 !important;
}
.shedEquipTitle {
  text-align: center;
  position: relative;
  display: table;
  line-height: 24px;
  background: rgba(0, 0, 0, 0.35);
  padding: 2px 10px 2px 10px;
  margin: auto;
  pointer-events: all;
  input[type="radio"] {
    zoom: 1.5;
    vertical-align: top;
    margin: 2px 5px 2px 0;
    z-index: 101px !important;
    pointer-events: all;
  }
  input[type="checkbox"] {
    zoom: 1.2;
    vertical-align: top;
    margin: 2px 5px 2px 0;
    z-index: 101px !important;
    pointer-events: all;
    background-color: #ccc;
    color: #000;
    font-size: 24px;
    font-weight: bolder;
  }
  input[type="checkbox"]::before {
    background-color: #ccc;
    color: #000;
  }
  span {
    font-size: 15px;
    font-family: "fontNormal";
  }
}

.picture {
  img {
    width: 360px;
    border: 1px solid #bbb;
    box-shadow: 3px 4px 9px #634040;
  }
}

.title {
  padding: 10px 0;
  img {
    vertical-align: middle;
  }
  span {
    color: #3fad92;
    font-size: 28px;
    vertical-align: middle;
  }
}
/*.information{*/
.infor_box {
  width: 100%;
  /*max-height: 1075px;*/
  display: flex;
  .infor_inner {
    width: 90%;
    .infor_params,
    .infor_zhili {
      position: relative;
      margin-bottom: 30px;
      .infor_params_title {
        font-size: 36px;
        &:before {
          content: "";
          width: 22px;
          height: 23px;
          background: rgba(61, 223, 226, 1);
          border-radius: 50%;
          position: absolute;
          top: 12px;
          left: -40px;
        }
      }
      .infor_params_box {
        color: #cadbe5;
        display: flex;
        flex-wrap: wrap;
        p {
          //width: 33%;
          line-height: 40px;
          /*margin-bottom: 16px;*/
          display: flex;
          flex-wrap: wrap;
          label {
            font-size: 20px;
          }
          span {
            display: inline-block;
            //width: 44%;
            margin-right: 30px;
            margin-bottom: 16px;
            color: #ccc;
            font-size: 18px;
            span {
              color: #3ddfe2;
              font-size: 20px;
            }
          }
          .infor_params_value {
            color: #3ddfe2;
            font-size: 20px;
          }
        }
      }
      .jiance_params_box {
        display: flex;
        flex-direction: column;
        p {
          width: 100%;
          label {
            width: 100%;
            display: block;
            margin-bottom: 16px;
          }
        }
      }
    }
    .infor_zhili {
      .infor_params_box {
        color: #cadbe5;
        display: block;
        p {
          width: 100%;
          display: flex;
          line-height: 40px;
          label {
          }
          span {
            line-height: 70px;
            span {
              color: #3ddfe2;
            }
          }
        }
      }
    }
  }
  .img_inner {
    //@include bg-box(100%, 400px, "img_iframe.png");
    padding: 4px;
    height: 70%;
    /*width: 40%;*/
    img {
      width: 100%;
      height: 100%;
      &:nth-of-type(1) {
        margin-bottom: 20px;
      }
    }
  }
  .img_p {
    line-height: 40px;
    text-align: center;
  }
}

img {
  display: inline-block;
}
</style>

<style lang="scss" scoped>
.info-wrap {
  padding: 30px 60px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  height: 250px;
  box-sizing: border-box;
  .matrial {
    width: 847px;
    height: 101px;
    font-size: 34px;
    line-height: 101px;
    text-align: center;
    background-image: url("./images/no_device.png");
    background-repeat: no-repeat;
    background-size: 100%;
    span {
      font-size: 34px;
      color: #00e7ff;
    }
  }
  .foggun-animation {
    width: 10%;
  }
  .basic-info {
    margin-left: 2%;
    width: 60%;
    height: 195px;
    overflow-y: auto;
  }
  .basic-info::-webkit-scrollbar {
    width: 6px;
  }
  .picture-info {
    margin-top: -10px;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-around;
    .picture-inner {
      width: 100%;
      p {
        color: #a2d8ff;
        font-size: 22px;
        line-height: 130px;
        text-align: center;
      }
      .picture {
        padding: 10px;
        width: 340px;
        height: 201px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-image: url("./images/img_bg.png");
        position: relative;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
        }
        &:before {
          content: "";
          position: absolute;
          top: 20px;
          right: 20px;
          width: 54px;
          height: 54px;
          background-image: url("./images/enlarge.png");
        }
      }
    }
  }
}
.shed-wrap {
  position: relative;
  width: 100%;
  height: 540px;
  overflow: visible;
  .video-tip,
  .tsp-tip,
  .celing-tip {
    position: absolute;
    box-sizing: border-box;
    padding: 5px;
    background-repeat: no-repeat;
    background-size: 100%;
    z-index: 9999;
  }
  .video-tip {
    width: 341px;
    height: 202px;
    background-image: url("./images/video_border.png");
    video {
      width: 100%;
      height: 100%;
    }
  }
  .tsp-tip {
    width: 339px;
    height: 173px;
    background-image: url("./images/tsp_border.png");
  }
  .celing-tip {
    width: 339px;
    height: 140px;
    background-size: 100% 100%;
    background-image: url("./images/celing_border.png");
  }
  img {
    width: 100%;
  }
  a {
    position: absolute;
    display: block;
  }
  a.hawkeye {
    width: 74px;
    height: 53px;
  }
  a.foggun,
  a.celingFogs {
    width: 134px;
    height: 105px;
  }
  a.washer {
    width: 105px;
    height: 155px;
  }
  a.tsp {
    width: 72px;
    height: 73px;
  }
  a > div {
    position: relative;
    width: 100%;
    height: 100%;
    img.actived {
      position: absolute;
      left: 38px;
      top: -50%;
      width: 57px;
      height: 76px;
    }
  }
  a > div > .tool-tip {
    position: absolute;
    left: 50%;
    top: 0;
    // padding: 5px;
    padding-left: 5px;
    padding-right: 5px;
    line-height: 2;
    font-size: 14px;
    color: white;
    text-align: center;
    background-color: rgba(0, 0, 0, 0.3);
    transform: translateX(-50%);
    white-space: nowrap;
  }
  a > div > img {
    width: 100%;
  }
}
.basic-box {
  position: absolute;
  right: 5px;
  bottom: -33px;
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-between;
  .basic,
  .basic-no-border {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-size: 20px;
    border: 1px solid #00a7ff;
    box-shadow: 0px 3px 6px #009dff;
    .item {
      padding: 10px 20px;
      text-align: center;
      border-left: 1px solid #00a7ff;
      .blue {
        color: #00e7ff;
      }
    }
    .item:first-child {
      border-left: none;
    }
  }
  .basic-no-border {
    margin-left: 20px;
    border: none;
    box-shadow: none;
    .item {
      border-left: none;
    }
  }
}
</style>
